import { EnumCourseSignupType } from '@xt/client/enums/course'
import { EnumModalOpStatus, EnumRegisterModalNames } from '@xt/client/enums/messageModalQueue'
import { EnumActivityBtnType, EnumSignStatusType } from '@xt/client/enums/activity'
import { Component, Prop, Vue } from 'vue-property-decorator'
import AUtils from '@xt/client/utils/activities/index'
import type { ActivityOptions } from '@xt/client/utils/activities/types'

@Component
export class MixinsActivityCommonUse extends Vue {
  _options: ActivityOptions
  _mobile: boolean = false

  get _isLogin() {
    return this.$store.$storeUser.isLogin()
  }

  get UserStore() {
    return this.$store.$storeUser
  }

  _showAgreementPop(type: EnumCourseSignupType) {
    this.$niceModal.show(EnumRegisterModalNames.Agreement, {
      id: this._options.productId,
      type
    })
  }

  // 赠课操作
  handleGift() {
    const { convertEndTime, signupStartTime } = this._options
    const res = AUtils.getGiftStatus({
      convertEndTime,
      signupStartTime
    })

    if (res) {
      // 检测用户是否登录
      this.$InspectUser()
      this._onCheckDevice()
      this._showAgreementPop(EnumCourseSignupType.Give)
    }
  }

  // 报名操作
  async handleSign() {
    try {
      this.$InspectUser()
      this._onCheckDevice()

      const signStatus = AUtils.getSignStatus(this._options)

      if (!signStatus) return

      if (signStatus === EnumSignStatusType.Jump) {
        this.$router.push({
          name: 'my'
        })
        return
      }

      const res = await this.$store.$storeOrder.checkBeforeOrder<{
        oldOrder: boolean
        oldOrderNo: number | null
        haveBuyActivity: boolean
        buyWay: number | null
        payAmount: number | null
        virtualCurrency: number | null
      }>(this._options.productId, false)

      if (res.oldOrder && res.oldOrderNo) {
        const group = await this.$niceModal.show<{
          status: EnumModalOpStatus
        }>(EnumRegisterModalNames.GroupPopup, {
          dataSource: {
            title: '当前课程您有未完成支付的订单~',
            waitPrice: res.payAmount ?? 0,
            count: (res.virtualCurrency ?? 0) / 100 / 8,
            ratio: 8,
            mainText: '继续支付', //右侧按钮
            viceText: '取消订单，重新报名',
            mainHeader: ''
          }
        })

        if (!group || !group.status) throw new Error('No Valid Status Obtained')

        if (group.status === EnumModalOpStatus.Ok) {
          /** 单独购买  取消订单 */
          await this.$store.$storeOrder.onOrderCancel({ orderNo: res.oldOrderNo })
          this._showAgreementPop(EnumCourseSignupType.Purchase)
        } else if (group.status === EnumModalOpStatus.Cancel) {
          /** 单独购买 继续支付 **/
          const query = {
            orderNo: String(res.oldOrderNo),
            productId: this._options.productId.toString(),
            give: res.buyWay == 1 ? String(false) : String(true),
            memberBeforeOption: String(true)
          }

          this.$router.push({
            name: 'payment',
            query
          })
        }

        return
      }

      this._showAgreementPop(EnumCourseSignupType.Purchase)
    } catch (error) {
      console.warn(error)
    }
  }

  async handleSignH5() {
    try {
      this._mobile = true
      this.$InspectUser()
      this._onCheckDevice()

      const signStatus = AUtils.getSignStatus(this._options)

      if (!signStatus) return

      if (signStatus === EnumSignStatusType.Jump) {
        if (this.$store.$global.isEmbeddedH5Page) {
          wx.miniProgram.switchTab({
            url: '/pages/toclass/index'
          })
        } else {
          this.$router.push({
            name: 'toclass'
            // name: "course-id",
            // params: { id:this.dataSource.id },
          })
        }
        return
      }

      const data = AUtils.mapCourseBtn(this._options, this._isLogin)

      if (data.type === EnumActivityBtnType.NoConvert) {
        this.$niceModal.show(EnumRegisterModalNames.SatisfiedPopup, {
          dataSource: {
            title: this._options.convertSignTitle,
            content: this._options.convertSignContent
          }
        })
        return
      }

      const res = await this.$store.$storeOrder.checkBeforeOrder<{
        oldOrder: boolean
        oldOrderNo: number | null
        haveBuyActivity: boolean
        buyWay: number | null
        payAmount: number | null
        virtualCurrency: number | null
      }>(this._options.productId, false)

      if (res.oldOrder && res.oldOrderNo) {
        const group = await this.$niceModal.show<{
          status: EnumModalOpStatus
        }>(EnumRegisterModalNames.GroupPopup, {
          dataSource: {
            title: '当前课程您有未完成支付的订单~',
            waitPrice: res.payAmount ?? 0,
            count: (res.virtualCurrency ?? 0) / 100 / 8,
            ratio: 8,
            mainText: '继续支付', //右侧按钮
            viceText: '取消订单，重新报名',
            mainHeader: ''
          }
        })

        if (!group || !group.status) throw new Error('No Valid Status Obtained')

        if (group.status === EnumModalOpStatus.Ok) {
          /** 单独购买  取消订单 */
          await this.$store.$storeOrder.onOrderCancel({ orderNo: res.oldOrderNo })
          this._showAgreementPop(EnumCourseSignupType.Purchase)
        } else if (group.status === EnumModalOpStatus.Cancel) {
          /** 单独购买 继续支付 **/
          const query = {
            orderNo: String(res.oldOrderNo),
            productId: this._options.productId.toString(),
            give: res.buyWay == 1 ? String(false) : String(true),
            memberBeforeOption: String(true)
          }

          if (this.$store.$global.isEmbeddedH5Page) {
            const querySplice = this.$router.resolve({ query }).href.split('?')[1]
            wx.miniProgram.navigateTo({
              url: `/pages/payment/index?${querySplice}`
            })
            return
          }
          // 微信内没有wxopenid id
          if (this.$store.$global.WechatBowser && this._mobile && !this.$store.$storeUser.wxOpenid) {
            // 获取 code 换取 openid
            window.location.replace(
              this.$store.$wechat.getAuthorizeUrl(
                window.location.origin + this.$router.resolve({ name: 'payment', query }).href,
                'snsapi_base'
              )
            )
            return false
          }

          this.$router.push({
            name: 'payment',
            query
          })
        }

        return
      }

      this._showAgreementPop(EnumCourseSignupType.Purchase)
    } catch (error) {
      console.warn(error)
    }
  }

  // 检测用户是否手机邮箱
  _onCheckDevice() {
    if (this.UserStore.needBindDevice) {
      if (this._mobile === true) {
        this.$router.push({
          name: 'other-bind'
        })
        throw this.$EnumLocaleLinks.links_bind_device
      }
      this.UserStore.onToggleModal(this.$EnumLocaleLinks.links_bind_device)
      throw this.$EnumLocaleLinks.links_bind_device
    }
    //   用户需要完善个人信息
    if (this.UserStore.onneedCompleteInfo()) {
      this.UserStore.onToggleModal(this.$EnumLocaleLinks.links_complete)
      throw this.$EnumLocaleLinks.links_complete
    }
  }

  init(dataSource: ActivityOptions) {
    this._options = dataSource
  }
}
